module.exports = __webpack_public_path__ + "static/img/Permiso(3).aacc553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(3).jpg
// module id = 9Etd
// module chunks = 0